<button mat-flat-button class="menu" color="primary" [matMenuTriggerFor]="menuNewOrder" [disabled]="isLoading()">
  {{"home.orders.newOrder" | translate}}<mat-icon>keyboard_arrow_down</mat-icon>
</button>
<mat-menu #menuNewOrder="matMenu" class="new-order-menu" xPosition="before">
    <button mat-menu-item (click)="newOrderProposal()">{{"newOrder.navigation.hechtProposal" | translate}}</button>
    <button mat-menu-item (click)="newOrderTrialLens()">{{"newOrder.navigation.trialLens" | translate}}</button>
    <button mat-menu-item (click)="newOrderFinalLens()">{{"newOrder.navigation.finalLens" | translate}}</button>
    <button mat-menu-item (click)="newOrderCare()">{{"home.orders.care" | translate}}</button>
    <button mat-menu-item (click)="newOrderAccessories()">{{"home.orders.accessories" | translate}}</button>
</mat-menu>
